<div *ngIf="showNotification" class="notification-container">
  <div class="notification">
    <div class="notification-header">
      <h3 class="notification-title">Pending Request</h3>
      <button class="close-btn" (click)="closeNotification()">×</button>
    </div>
    <div class="notification-content" (click)="navigateToPending()">
      You have pending requests from the supply chain.<br><br> Please click here to view the order and take necessary action.
    </div>
  </div>
</div>